import { NoteReferenceDestination } from "../note-reference-destination";
export class FootNoteReferenceDestination extends NoteReferenceDestination {
    get notes() {
        return this.data.footNotesImporter.notes;
    }
    insertNoteRun(subDocId) {
        this.data.footNotesImporter.insertRun(subDocId);
    }
}
